import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { appRoutes } from '../app.routes';
import { Router } from '@angular/router';
import { PermissionService } from '../core/services/permission.service';
import { UserService } from '../core/services/user.service';
import { PrimeNGModule } from '../config/primeng';
import { AuthenticateService } from '../core/services/authenticate.service';
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-sidebar',
  imports: [PrimeNGModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class SidebarComponent implements OnInit {
  appVersion: string = packageJson.version;
  items: MenuItem[] = [];

  constructor(
    private router: Router,
    private permissionService: PermissionService,
    public userService: UserService,
    private authService: AuthenticateService
  ) { }

  ngOnInit() {
    const mainRoute = appRoutes.find(r => r.children);
    let menuRoutes: any[] = [];

    if (mainRoute && mainRoute.children) {
      menuRoutes = [...mainRoute.children];
    }

    // Find top-level standalone routes that should be in the menu (e.g. Air Quality)
    const standaloneRoutes = appRoutes.filter(r => !r.children && r.path && r.path !== 'login' && r.path !== '404' && r.path !== '**' && r.data && r.data['label']);
    menuRoutes = [...menuRoutes, ...standaloneRoutes];

    this.items = this.buildMenuItems(menuRoutes);
  }

  logout() {
    this.authService.apiPostAuthLogout().subscribe({
      next: () => {
        // Logout actions are handled by interceptor/service automatically!
        this.permissionService.clearPermissions();
      },
      error: (err) => {
        console.error('Logout failed:', err);
        // Fallback clear
        localStorage.removeItem('access_token');
        this.permissionService.clearPermissions();
        this.router.navigate(['/login']);
      }
    });
  }

  private buildMenuItems(routes: any[], parentPath: string = ''): MenuItem[] {
    const items: MenuItem[] = [];

    for (const route of routes) {
      if (!route.data || !route.data['label'] || route.data['hidden']) continue;

      const requiredPerm = route.data['requiredPermission'];
      if (requiredPerm && !this.permissionService.hasPermission(requiredPerm)) {
        continue;
      }

      const fullPath = parentPath ? `${parentPath}/${route.path}` : `/${route.path}`;
      const menuItem: MenuItem = {
        label: route.data['label'],
        icon: route.data['icon'],
        expanded: false
      };

      const hasSidebarChildren = route.children && route.children.some((child: any) => child.data && child.data['label'] && !child.data['hidden']);

      if (hasSidebarChildren) {
        const children = this.buildMenuItems(route.children, fullPath);
        if (children.length > 0) {
          menuItem.items = children;
          items.push(menuItem);
        }
      } else {
        menuItem.routerLink = [fullPath];
        items.push(menuItem);
      }
    }

    return items;
  }
}
